import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

export default function NewSessionModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const [name, setName] = useState("");

    function hide ()
    {
	setName("");
	props.hide();
    }

    function handleNameChange (e) { setName(e.target.value); }

    function newSession ()
    {
	gDispatch({ type: "newSession", password: gData.session.password, name });
    }

    
    return (
	<Modal
	    show={props.show}
	    onHide={hide}
	    centered
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title>Créer une nouvelle session</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form className="d-flex flex-column gap-3 align-items-end">
		    <Form.Group className="w-100">
			<Form.Label>Titre de la session</Form.Label>
			<Form.Control size="lg" autoFocus className="text-center" maxLength="45" value={name} onChange={handleNameChange} aria-label="Titre de la session"/>
		    </Form.Group>

		    <Button variant="primary" type="submit" disabled={name.length === 0} onClick={(e) => { e.preventDefault(); newSession(); }}>Valider</Button>
		</Form>
	    </Modal.Body>
	</Modal>
    );
}

